import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

const state = {
	now: new Date(),
	user: {
		id: null,
		roles: [],
		name: null,
		phone: null,
		avatar: null,
		webTokens: [],
	},
	loaded: {
		users: new Set(),
		pets: new Set(),
	},
	tickets: [],
	chats: [],
	users: [],
	pets: [],
	admins: [],
	articles: [],
	categories: [],
	stories: [],
	consultations: [],
	calls: [],
	typingUsers: [],
}

export default new Vuex.Store({
	state,
	mutations,
	actions,
	getters,
})
